import React from "react";
import { Link } from "react-router-dom";
import JobCard from "../Jobs/JobCard";
import { mapApiJob } from "../../utils/jobFormatters";

const FeaturedJobs = ({ jobs = [], isLoading }) => {
  return (
    <section className="job-section">
      <div className="auto-container">
        <div className="sec-title text-center">
          <h2>Featured Jobs</h2>
          <div className="text">Know your worth and find the job that qualifies your life.</div>
        </div>

        {isLoading && <h5 className="text-center my-3">Loading Data</h5>}

        <div className="row wow fadeInUp">
          {!isLoading && jobs.map((job) => (
            <div className="col-lg-6 col-md-12 col-sm-12" key={job.id}>
              <JobCard job={mapApiJob(job)} />
            </div>
          ))}
        </div>

        {!isLoading && jobs.length === 0 && (
          <div className="employee-empty-state">No featured jobs available yet.</div>
        )}

        <div className="btn-box">
          <Link to="/jobs" className="theme-btn btn-style-one bg-blue">
            <span className="btn-title">Load More Listing</span>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FeaturedJobs;
